import { Button, Dropdown, Form, Input, Menu, Space, Typography } from "antd";
import { DistributeTokenWrapper, FormWrapper } from "./index.styled";
import { NETWORKS } from "../../../../_shared";
const {Text} = Typography;

interface DistributeTokenComponentProps{
    handleClaimPercentage : ()=>void;
    onFinish? : ()=>void;
    distributedTokenLoaded?: boolean
}
export const DistributeTokenComponent = (props: DistributeTokenComponentProps) => {
    const {handleClaimPercentage, onFinish, distributedTokenLoaded} = props;
    const menu = (
        <Menu
          items={
            NETWORKS.map((network, index)=>({
              key: index,
              label: (
                <span>
                  {network.label}
                </span>
              ),
            }))
            }
        />
      );

    return (
          <DistributeTokenWrapper>
            <Space className="top-bar" align="center">
                <Dropdown overlay={menu} placement="bottom" >
                    <Button  type="primary">
                        <Space>
                            <span>Ethereum</span>
                            <img src="/caret-double.svg" alt="..." />
                        </Space>
                    </Button>
                </Dropdown>
                <Button type="primary" ghost onClick={handleClaimPercentage}>
                  View Vesting Schedule
                </Button>
            </Space>
            {!distributedTokenLoaded && <FormWrapper
                name="distribution_token"
                layout="vertical"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                autoComplete="off"
                requiredMark={'optional'}
                >
                <Form.Item
                    label="Token Address"
                    name="token_address"
                    // requiredMark={'optional'}
                    rules={[{ required: true, message: 'Please input token address!' }]}
                >
                    <Input placeholder="Enter Contact Address here" />
                </Form.Item>
                <Form.Item
                    label="Token Quantity"
                    name="token_quantity"
                    // requiredMark={'optional'}
                    rules={[{ required: true, message: 'Please input token quantity!' }]}
                >
                    <Input  placeholder="Enter Token Quantity" />
                </Form.Item>
                <Form.Item>
                    <Button className="float-right" type="primary" htmlType="submit">
                      Start Distribution
                    </Button>
                </Form.Item>
            </FormWrapper>}
            {distributedTokenLoaded && 
            <Space className="space-wrapper" direction="vertical" size={24}>
              
                <Space className="list-item-row">
                    <Text>Token Address</Text>
                    <Text>0x9289hh237xbw8q9x7wjis9d</Text>
                </Space>

                <Space className="list-item-row">
                    <Text>Token Quantity</Text>
                    <Text>100</Text>
                </Space>

                <Space className="list-item-row">
                    <Text>Total Claimed</Text>
                    <Text>892809802902 REM</Text>
                </Space>

                <Space className="list-item-row">
                    <Text>Total Left</Text>
                    <Text>892809802 REM</Text>
                </Space>
                
            </Space>}
          </DistributeTokenWrapper>
    );
};